import styled from 'styled-components';
import { palette } from 'styled-theme';
import { Link } from 'react-router-dom';

export const NotificationList = styled('ul')`
  padding: 0;
  margin: 0;
  margin-block-end: 0;
  display: flex;
  flex-direction: column;
`;

export const InlineLink = styled(Link)`
  display: inline !important;
  pointer-events: all;
  padding: 0 !important;
  color: ${palette('secondary', 0)} !important;

  &:hover {
    background-color: transparent !important;
    text-decoration: underline !important;
  }
`;

export const SubBody = styled('div')`
  margin-top: 10px;
  line-height: 1.4;
`;

export const Feedback = styled('span')`
  .showMoreTextButton {
    pointer-events: auto;
    display: inline-block !important;
    width: auto !important;
    padding: 0 !important;
    color: ${palette('secondary', 0)} !important;
  }
`;
